import { useEffect, useState, useCallback } from 'react';
import styles from './AddUpdateStrategyForm.module.scss';
import { useNavigate } from 'react-router-dom';
import {
	packaging_strategy_all_endpoints,
	//access_service,
	user_management_service,
} from 'src/constants/url';
import { baseApiCall } from 'src/api/Api';
//import './AddUserstyle.scss'; // this for multi-select disable colour
import {
	BackButton,
	Button,
	CustomTab,
	ErrorModal,
	FileInputSection,
	SuccessModal,
} from 'src/components';
import { darftedData, onResponse, reuploadedData } from 'src/redux/features';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import globalstyle from 'src/assets/scss/global.module.scss';
import useAuthorizationContext from 'src/providers/AuthorizationHandler/useAuthorizationContext';
import {
	packaging_Details,
	error_Message,
	packagingDetailsRegex,
	requiredFields,
	errorMsg,
	primaryRequiredFields,
	secondaryRequiredFields,
	recommendedFields,
} from './constants';
import { Title, commonVaribles } from 'src/constants/constVariables';
import {
	formatDateInYMD,
	convertUTCtoISTInYMD,
	matchOption,
	uploadExcelFile,
} from 'src/constants/utils';
import {
	complyingOptions,
	plasticPackagingRecyclingGuidelines,
	recycledContentGuidelines,
} from 'src/constants/constant';
import clsx from 'clsx';
import { ConfirmationModal } from 'src/components/Modals/ConfirmationModal';

export const AddUpdateStrategyForm = () => {
	const navigate = useNavigate();
	const { user } = useAuthorizationContext();
	const dispatch = useDispatch();
	//const { plants } = useSelector((state) => state?.allPlants || {});
	const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
	const [recommendedWarningAcknowledged, setRecommendedWarningAcknowledged] =
		useState(false);
	const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
	const [missingRecommendedFields, setMissingRecommendedFields] = useState([]);
	const [statusCode, setStatusCode] = useState('');
	const [headerTitleName, setHeaderTitleName] = useState('');
	const [packagingDetails, setPackagingDetails] = useState(packaging_Details);
	const [errorMessage, setErrorMessage] = useState(error_Message);
	const [isButtonDisable, setIsButtonDisable] = useState(true);
	const [isModalOpen, setModalIsOpen] = useState(false);
	const [title, setTitle] = useState('');
	const [directMaterialPurchaseBuyerList, setDirectMaterialPurchaseBuyerList] =
		useState([]);
	const [commodityTypeList, setCommodityTypeList] = useState([]);
	const plantDataList = useSelector((state) => state.allPlants.plants);
	const [excelfile, setexcelfile] = useState([]);

	const [isUploaded, setisUploaded] = useState({
		part_only_image: false,
		part_dunnage_primary_packaging_image: false,
		primary_plus_secondary_packaging_image: false,
	});

	const [isEdited, setIsEdited] = useState(false);
	const [isDrafted, setIsDrafted] = useState(false);
	const {
		reuploadData: { reuploadeddata },
		draftedData: { drafteddata },
	} = useSelector((state) => state);

	const [select, setSelect] = useState({
		primary_is_the_packaging_collected_and_taken_back_by_supplier: null,
		secondary_is_the_packaging_collected_and_taken_back_by_supplier: null,
		selected_plant_id: null,
		selected_commodity_type_details: null,
		selected_dmp_user_details: null,
	});

	const [isButtonDisabled, setIsButtonDisabled] = useState(false);

	const handleDataChange = (event) => {
		const { name, value } = event.target;

		// Update the packaging details
		setPackagingDetails((prev) => ({
			...prev,
			[name]: value,
		}));
		setIsButtonDisabled(false);

		// Dynamically get the regex pattern based on the name
		const regexPattern = packagingDetailsRegex[name];

		if (regexPattern && !regexPattern.test(value) && value !== '') {
			setErrorMessage((prev) => ({
				...prev,
				[name]: true,
			}));
		} else {
			setErrorMessage((prev) => ({
				...prev,
				[name]: false,
			}));
		}
	};

	useEffect(() => {
		if (window?.location?.pathname?.includes('draft-strategy')) {
			setHeaderTitleName(Title?.edit_draft_strategy);
			setIsDrafted(true);
			if(!drafteddata) {
				navigate('/packaging-strategy')
			}
		}
		else if (window?.location?.pathname?.includes('update-strategy')) {
			setHeaderTitleName(Title.edit_strategy);
			setIsEdited(true);
			if (!reuploadeddata) {
				navigate('/packaging-strategy');
			}
		} else {
			setHeaderTitleName(Title.add_strategy);
			dispatch(reuploadedData(null));
			dispatch(darftedData(null));
			setIsDrafted(false);
			setIsEdited(false);
		}
		// if (select?.selected_plant_id?.value) {
		// 	fetchUserRoleWiseList();
		// }
		return () => {
			dispatch(reuploadedData(null));
			dispatch(darftedData(null));
		};
	}, []);

	useEffect(() => {
		if (select?.selected_plant_id?.value) {
			fetchCommodityList();
		}
	}, [select?.selected_plant_id?.value]);

	useEffect(() => {
		if (select?.selected_commodity_type_details?.value) {
			fetchUserRoleWiseList();
		}
	}, [select?.selected_commodity_type_details?.value]);

	useEffect(() => {
		if (reuploadeddata) {
			setPackagingDetails({
				company_name:
					reuploadeddata?.Strategies_table?.supply_info_data?.company_name,
				company_address:
					reuploadeddata?.Strategies_table?.supply_info_data?.company_address,
				pkg_person_contact_name:
					reuploadeddata?.Strategies_table?.supply_info_data?.contact_person,
				email: reuploadeddata?.Strategies_table?.supply_info_data?.email,
				vendor_code:
					reuploadeddata?.Strategies_table?.supply_info_data?.vendor_code,
				state: reuploadeddata?.Strategies_table?.supply_info_data?.state,
				tel_no: reuploadeddata?.Strategies_table?.supply_info_data?.tel_no,
				fax_no: reuploadeddata?.Strategies_table?.supply_info_data?.fax_no,
				primary_density:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_density,
				primary_packaging_strategy:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_packaging_strategy,
				primary_carton_code:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_carton_code,
				primary_carton_type:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_carton_type,
				primary_packaging_material_type:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_packaging_material,
				primary_securement_type:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_securement,
				primary_total_loaded:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_total_Loaded,
				primary_outside_dimension:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_outside_dimension,
				primary_dunnage_description:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_dunnage_description,
				primary_labels:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_labels,
				primary_container_ownership:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_container_ownership,
				primary_type_of_plastic_packaging_supplied_along_with_Parts:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_type_of_plastic_packaging_supplied,
				primary_is_the_packaging_collected_and_taken_back_by_supplier:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_is_the_packaging_collected,
				primary_are_you_complying_to_pwm_epr_rules:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_complying_to_pwm_epr_rules,
				primary_share_your_pwn_epr_registration:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_pwm_epr_registration_no,
				primary_share_your_plastic_packaging_supplier_pwm_epr_registration_number:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_plastic_packaging_supplier_pwm_epr_registration_no,
				primary_are_you_complying_with_the_pwm_epr_labeling_requirement:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_pwm_epr_labeling_requirement,
				primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_pwm_epr_plastic_packaging_recycling_requirement,
				primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_pwm_epr_plastic_packaging_recycled_content_requirement,
				primary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_current_percent_recycled_content_in_plastic_packaging,
				primary_remarks_other_details:
					reuploadeddata?.Strategies_table?.primary_packaging_info
						?.primary_remarks,
				secondary_density:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_density,
				secondary_packaging_strategy:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_packaging_strategy,
				secondary_carton_code:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_carton_Code,
				secondary_carton_type:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_carton_Type,
				secondary_packaging_material_type:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_packaging_material,
				secondary_securement_type:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_securement,
				secondary_total_loaded:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_total_loaded,
				secondary_outside_dimension:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_outside_dimension,
				secondary_dunnage_description:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_dunnage_description,
				secondary_labels:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_labels,
				secondary_container_ownership:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_container_ownership,
				secondary_type_of_plastic_packaging_supplied_along_with_Parts:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_type_of_plastic_packaging_supplied,
				secondary_is_the_packaging_collected_and_taken_back_by_supplier:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_is_the_packaging_collected,
				secondary_are_you_complying_to_pwm_epr_rules:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_complying_to_pwm_epr_rules,
				secondary_share_your_pwn_epr_registration:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_pwm_epr_registration_no,
				secondary_share_your_plastic_packaging_supplier_pwm_epr_registration_number:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_plastic_packaging_supplier_pwm_epr_registration_no,
				secondary_are_you_complying_with_the_pwm_epr_labeling_requirement:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_pwm_epr_labeling_requirement,
				secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_pwm_epr_plastic_packaging_recycling_requirement,
				secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_plastic_packaging_recycled_content_requirement,
				secondary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_current_percent_recycled_content_plastic_packaging,
				secondary_remarks_other_details:
					reuploadeddata?.Strategies_table?.secondary_packaging_info
						?.secondary_remarks,
				transportation_mode:
					reuploadeddata?.Strategies_table?.shipping_info?.transportation_mode,
				pallet_dimensions:
					reuploadeddata?.Strategies_table?.shipping_info?.pallet_dimensions,
				no_of_pallets_per_vehicle:
					reuploadeddata?.Strategies_table?.shipping_info
						?.no_of_pallets_per_vehicle,
				stackable_non_stackable:
					reuploadeddata?.Strategies_table?.shipping_info
						?.stackable_non_stackable,
				sec_packaging_per_transit_modes:
					reuploadeddata?.Strategies_table?.shipping_info
						?.sec_packaging_per_transit_modes,
				no_of_pry_packs_per_sec_packs:
					reuploadeddata?.Strategies_table?.shipping_info
						?.no_of_pry_packs_per_sec_packs,
				inco_term: reuploadeddata?.Strategies_table?.shipping_info?.inco_terms,
				hazardous_material_class:
					reuploadeddata?.Strategies_table?.shipping_info
						?.hazardous_material_class,
				loop_size: reuploadeddata?.Strategies_table?.shipping_info?.loop_size,
				life_of_returnable_packaging:
					reuploadeddata?.Strategies_table?.shipping_info
						?.life_returnable_packaging,
				unloading_loading_responsibility:
					reuploadeddata?.Strategies_table?.shipping_info
						?.unloading_loading_responsibility,
				supply_at_tml:
					reuploadeddata?.Strategies_table?.shipping_info?.supply_tml,
				theoretical_cubic_utilisation:
					reuploadeddata?.Strategies_table?.shipping_info
						?.theoretical_cubic_utilisation,
				remarks: reuploadeddata?.Strategies_table?.shipping_info?.remarks,
				//packaging_person: reuploadeddata?.Strategies_table?.approval_info?.packaging_person,
				//purchasing_buyer_tml: reuploadeddata?.Strategies_table?.approval_info?.purchasing_buyer,
				//scm_tml: reuploadeddata?.Strategies_table?.approval_info?.scm,
				//packaging_person_date: formatDateInYMD(reuploadeddata?.Strategies_table?.approval_info?.packaging_person_date),
				//purchasing_buyer_tml_date: formatDateInYMD(reuploadeddata?.Strategies_table?.approval_info?.purchasing_buyer_date),
				//scm_tml_date: formatDateInYMD(reuploadeddata?.Strategies_table?.approval_info?.scm_date),
				tata_motors_receiving_location:
					reuploadeddata?.Strategies_table?.part_info_data?.receiving_location,
				tml_part_no: reuploadeddata?.Strategies_table?.part_info_data?.part_no,
				tml_part_description:
					reuploadeddata?.Strategies_table?.part_info_data?.part_description,
				part_weight:
					reuploadeddata?.Strategies_table?.part_info_data?.part_weight,
				part_dimensions:
					reuploadeddata?.Strategies_table?.part_info_data?.part_dimension,
				annual_volume:
					reuploadeddata?.Strategies_table?.part_info_data?.annual_volume,
				no_of_parts_per_vehicle:
					reuploadeddata?.Strategies_table?.part_info_data?.part_per_vehicle,
				packaging_cost:
					reuploadeddata?.Strategies_table?.part_info_data
						?.supplier_packaging_cost,
				transportation_cost:
					reuploadeddata?.Strategies_table?.part_info_data
						?.supplier_transport_cost,
				models_applicable:
					reuploadeddata?.Strategies_table?.part_info_data?.models_applicable,
				part_only_image:
					reuploadeddata?.Strategies_table?.visual_reference?.part_only_image,
				part_dunnage_primary_packaging_image:
					reuploadeddata?.Strategies_table?.visual_reference
						?.part_dunnage_primary_packaging_image,
				primary_plus_secondary_packaging_image:
					reuploadeddata?.Strategies_table?.visual_reference
						?.primary_plus_secondary_packaging_image,
				user_name: user?.name,
				//selected_plant_id: reuploadeddata?.Strategies_table?.plant_id,
				//selected_dmp_user_details: reuploadeddata?.Strategies_table?.plant_id,
				//approval_type: reuploadeddata?.Strategies_table?.approval_info?.approval_type,
				//approval_status: reuploadeddata?.Strategies_table?.approval_info?.approval_status,
				//approval_type_date: formatDateInYMD(reuploadeddata?.Strategies_table?.approval_info?.approval_date),
				is_updated: isEdited,
			});

			setSelect((prevState) => ({
				...prevState,
				primary_is_the_packaging_collected_and_taken_back_by_supplier:
					matchOption(
						reuploadeddata?.Strategies_table?.primary_packaging_info
							?.primary_is_the_packaging_collected,
						complyingOptions
					),
				secondary_is_the_packaging_collected_and_taken_back_by_supplier:
					matchOption(
						reuploadeddata?.Strategies_table?.secondary_packaging_info
							?.secondary_is_the_packaging_collected,
						complyingOptions
					),
				selected_plant_id: matchOption(
					reuploadeddata?.Strategies_table?.plant_id,
					plantDataList
				),
				selected_dmp_user_details: matchOption(
					reuploadeddata?.Strategies_table?.dmp_buyer_status_evaluated_id,
					directMaterialPurchaseBuyerList
				),
				selected_commodity_type_details: matchOption(
					reuploadeddata?.Strategies_table?.commodity_type_id,
					commodityTypeList
				)
			}));
		}
	}, [reuploadeddata]);

	useEffect(() => {
		if (drafteddata) {
			setPackagingDetails({
				company_name:
					drafteddata?.Strategies_table?.supply_info_data?.company_name,
				company_address:
					drafteddata?.Strategies_table?.supply_info_data?.company_address,
				pkg_person_contact_name:
					drafteddata?.Strategies_table?.supply_info_data?.contact_person,
				email: drafteddata?.Strategies_table?.supply_info_data?.email,
				vendor_code:
					drafteddata?.Strategies_table?.supply_info_data?.vendor_code,
				state: drafteddata?.Strategies_table?.supply_info_data?.state,
				tel_no: drafteddata?.Strategies_table?.supply_info_data?.tel_no,
				fax_no: drafteddata?.Strategies_table?.supply_info_data?.fax_no,
				primary_density:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_density,
				primary_packaging_strategy:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_packaging_strategy,
				primary_carton_code:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_carton_code,
				primary_carton_type:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_carton_type,
				primary_packaging_material_type:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_packaging_material,
				primary_securement_type:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_securement,
				primary_total_loaded:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_total_Loaded,
				primary_outside_dimension:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_outside_dimension,
				primary_dunnage_description:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_dunnage_description,
				primary_labels:
					drafteddata?.Strategies_table?.primary_packaging_info?.primary_labels,
				primary_container_ownership:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_container_ownership,
				primary_type_of_plastic_packaging_supplied_along_with_Parts:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_type_of_plastic_packaging_supplied,
				primary_is_the_packaging_collected_and_taken_back_by_supplier:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_is_the_packaging_collected,
				primary_are_you_complying_to_pwm_epr_rules:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_complying_to_pwm_epr_rules,
				primary_share_your_pwn_epr_registration:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_pwm_epr_registration_no,
				primary_share_your_plastic_packaging_supplier_pwm_epr_registration_number:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_plastic_packaging_supplier_pwm_epr_registration_no,
				primary_are_you_complying_with_the_pwm_epr_labeling_requirement:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_pwm_epr_labeling_requirement,
				primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_pwm_epr_plastic_packaging_recycling_requirement,
				primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_pwm_epr_plastic_packaging_recycled_content_requirement,
				primary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_current_percent_recycled_content_in_plastic_packaging,
				primary_remarks_other_details:
					drafteddata?.Strategies_table?.primary_packaging_info
						?.primary_remarks,
				secondary_density:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_density,
				secondary_packaging_strategy:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_packaging_strategy,
				secondary_carton_code:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_carton_Code,
				secondary_carton_type:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_carton_Type,
				secondary_packaging_material_type:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_packaging_material,
				secondary_securement_type:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_securement,
				secondary_total_loaded:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_total_loaded,
				secondary_outside_dimension:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_outside_dimension,
				secondary_dunnage_description:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_dunnage_description,
				secondary_labels:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_labels,
				secondary_container_ownership:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_container_ownership,
				secondary_type_of_plastic_packaging_supplied_along_with_Parts:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_type_of_plastic_packaging_supplied,
				secondary_is_the_packaging_collected_and_taken_back_by_supplier:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_is_the_packaging_collected,
				secondary_are_you_complying_to_pwm_epr_rules:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_complying_to_pwm_epr_rules,
				secondary_share_your_pwn_epr_registration:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_pwm_epr_registration_no,
				secondary_share_your_plastic_packaging_supplier_pwm_epr_registration_number:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_plastic_packaging_supplier_pwm_epr_registration_no,
				secondary_are_you_complying_with_the_pwm_epr_labeling_requirement:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_pwm_epr_labeling_requirement,
				secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_pwm_epr_plastic_packaging_recycling_requirement,
				secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_plastic_packaging_recycled_content_requirement,
				secondary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_current_percent_recycled_content_plastic_packaging,
				secondary_remarks_other_details:
					drafteddata?.Strategies_table?.secondary_packaging_info
						?.secondary_remarks,
				transportation_mode:
					drafteddata?.Strategies_table?.shipping_info?.transportation_mode,
				pallet_dimensions:
					drafteddata?.Strategies_table?.shipping_info?.pallet_dimensions,
				no_of_pallets_per_vehicle:
					drafteddata?.Strategies_table?.shipping_info
						?.no_of_pallets_per_vehicle,
				stackable_non_stackable:
					drafteddata?.Strategies_table?.shipping_info?.stackable_non_stackable,
				sec_packaging_per_transit_modes:
					drafteddata?.Strategies_table?.shipping_info
						?.sec_packaging_per_transit_modes,
				no_of_pry_packs_per_sec_packs:
					drafteddata?.Strategies_table?.shipping_info
						?.no_of_pry_packs_per_sec_packs,
				inco_term: drafteddata?.Strategies_table?.shipping_info?.inco_terms,
				hazardous_material_class:
					drafteddata?.Strategies_table?.shipping_info
						?.hazardous_material_class,
				loop_size: drafteddata?.Strategies_table?.shipping_info?.loop_size,
				life_of_returnable_packaging:
					drafteddata?.Strategies_table?.shipping_info
						?.life_returnable_packaging,
				unloading_loading_responsibility:
					drafteddata?.Strategies_table?.shipping_info
						?.unloading_loading_responsibility,
				supply_at_tml: drafteddata?.Strategies_table?.shipping_info?.supply_tml,
				theoretical_cubic_utilisation:
					drafteddata?.Strategies_table?.shipping_info
						?.theoretical_cubic_utilisation,
				remarks: drafteddata?.Strategies_table?.shipping_info?.remarks,
				//packaging_person: drafteddata?.Strategies_table?.approval_info?.packaging_person,
				//purchasing_buyer_tml: drafteddata?.Strategies_table?.approval_info?.purchasing_buyer,
				//scm_tml: drafteddata?.Strategies_table?.approval_info?.scm,
				//packaging_person_date: formatDateInYMD(drafteddata?.Strategies_table?.approval_info?.packaging_person_date),
				//purchasing_buyer_tml_date: formatDateInYMD(drafteddata?.Strategies_table?.approval_info?.purchasing_buyer_date),
				//scm_tml_date: formatDateInYMD(drafteddata?.Strategies_table?.approval_info?.scm_date),
				tata_motors_receiving_location:
					drafteddata?.Strategies_table?.part_info_data?.receiving_location,
				tml_part_no: drafteddata?.Strategies_table?.part_info_data?.part_no,
				tml_part_description:
					drafteddata?.Strategies_table?.part_info_data?.part_description,
				part_weight: drafteddata?.Strategies_table?.part_info_data?.part_weight,
				part_dimensions:
					drafteddata?.Strategies_table?.part_info_data?.part_dimension,
				annual_volume:
					drafteddata?.Strategies_table?.part_info_data?.annual_volume,
				no_of_parts_per_vehicle:
					drafteddata?.Strategies_table?.part_info_data?.part_per_vehicle,
				packaging_cost:
					drafteddata?.Strategies_table?.part_info_data
						?.supplier_packaging_cost,
				transportation_cost:
					drafteddata?.Strategies_table?.part_info_data
						?.supplier_transport_cost,
				models_applicable:
					drafteddata?.Strategies_table?.part_info_data?.models_applicable,
				part_only_image:
					drafteddata?.Strategies_table?.visual_reference?.part_only_image,
				part_dunnage_primary_packaging_image:
					drafteddata?.Strategies_table?.visual_reference
						?.part_dunnage_primary_packaging_image,
				primary_plus_secondary_packaging_image:
					drafteddata?.Strategies_table?.visual_reference
						?.primary_plus_secondary_packaging_image,
				user_name: user?.name,
				//selected_plant_id: drafteddata?.Strategies_table?.plant_id,
				//selected_dmp_user_details: drafteddata?.Strategies_table?.plant_id,
				//approval_type: drafteddata?.Strategies_table?.approval_info?.approval_type,
				//approval_status: drafteddata?.Strategies_table?.approval_info?.approval_status,
				//approval_type_date: formatDateInYMD(drafteddata?.Strategies_table?.approval_info?.approval_date),
				is_updated: isEdited,
			});

			setSelect((prevState) => ({
				...prevState,
				primary_is_the_packaging_collected_and_taken_back_by_supplier:
					matchOption(
						drafteddata?.Strategies_table?.primary_packaging_info
							?.primary_is_the_packaging_collected,
						complyingOptions
					),
				secondary_is_the_packaging_collected_and_taken_back_by_supplier:
					matchOption(
						drafteddata?.Strategies_table?.secondary_packaging_info
							?.secondary_is_the_packaging_collected,
						complyingOptions
					),
				selected_plant_id: matchOption(
					drafteddata?.Strategies_table?.plant_id,
					plantDataList
				),
			}));
		}
	}, [drafteddata]);

	const fetchUserRoleWiseList = () => {
		setDirectMaterialPurchaseBuyerList([]);

		const req_user_role_names = ['Direct Material Purchase Buyer'];
		baseApiCall({
			url: user_management_service.GET_USER_ROLE_DETAILS_BY_ROLE,
			requestBody: {
				plant_id: select?.selected_plant_id?.value,
				user_role_names: req_user_role_names,
				commodity_type_id: select.selected_commodity_type_details?.value,
				is_dropdown_value: true,
				Skipinterceptors: true,
			},
			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res?.data?.result && res?.data?.result !== '') {
					const data = res.data.result;
					setDirectMaterialPurchaseBuyerList(data?.[req_user_role_names[0]]);
					if(isEdited || isDrafted) {
						const dmpUserId = isDrafted ? drafteddata?.Strategies_table?.dmp_buyer_status_evaluated_id : reuploadeddata?.Strategies_table?.dmp_buyer_status_evaluated_id;
						if(dmpUserId) {
							const selectedDmpUser = data?.[req_user_role_names[0]]?.find((dmpUser) => dmpUser?.value === dmpUserId ) ?? null;
							setSelect({
								...select,
								selected_dmp_user_details: selectedDmpUser
							})
						}
					}
				}
			},
			onFailure: () => {},
			errorCall: () => {},
		});
	};

	const fetchCommodityList = () => {
		setCommodityTypeList([]);
		baseApiCall({
			url: user_management_service.GET_COMMODITY_TYPE_ROLE_DETAILS,
			requestBody: {
				plant_id: select?.selected_plant_id?.value,
				Skipinterceptors: true,
			},
			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res && res?.data && res?.data?.result && res?.data?.result !== '') {
					const data = res?.data?.result;
					setCommodityTypeList(data);
					if(isEdited || isDrafted) {
						const commodityId = isDrafted ? drafteddata?.Strategies_table?.commodity_type_id : reuploadeddata?.Strategies_table?.commodity_type_id;
						if(commodityId) {
							const selectedCommodity = data?.find((commodity) => commodity?.value === commodityId ) ?? null;
							setSelect({
								...select,
								selected_commodity_type_details: selectedCommodity,
							});
						}
					}
				}
			},
			onFailure: () => {},
			errorCall: () => {},
		});
	};

	const submitForm = () => {
		baseApiCall({
			url: packaging_strategy_all_endpoints.POST_ADD_NEW_STRATEGY,
			requestBody: {
				company_name: packagingDetails?.company_name,
				company_address: packagingDetails?.company_address,
				pkg_person_contact_name: packagingDetails?.pkg_person_contact_name,
				email: packagingDetails?.email,
				vendor_code: packagingDetails?.vendor_code,
				state: packagingDetails?.state,
				tel_no: packagingDetails?.tel_no,
				fax_no: packagingDetails?.fax_no,
				primary_density: packagingDetails?.primary_density,
				primary_packaging_strategy:
					packagingDetails?.primary_packaging_strategy,
				primary_carton_code: packagingDetails?.primary_carton_code,
				primary_carton_type: packagingDetails?.primary_carton_type,
				primary_packaging_material_type:
					packagingDetails?.primary_packaging_material_type,
				primary_securement_type: packagingDetails?.primary_securement_type,
				primary_total_loaded: packagingDetails?.primary_total_loaded,
				primary_outside_dimension: packagingDetails?.primary_outside_dimension,
				primary_dunnage_description:
					packagingDetails?.primary_dunnage_description,
				primary_labels: packagingDetails?.primary_labels,
				primary_container_ownership:
					packagingDetails?.primary_container_ownership,
				primary_type_of_plastic_packaging_supplied_along_with_Parts:
					packagingDetails?.primary_type_of_plastic_packaging_supplied_along_with_Parts,
				primary_is_the_packaging_collected_and_taken_back_by_supplier:
					select?.primary_is_the_packaging_collected_and_taken_back_by_supplier
						?.value,
				primary_are_you_complying_to_pwm_epr_rules:
					packagingDetails?.primary_are_you_complying_to_pwm_epr_rules,
				primary_share_your_pwn_epr_registration:
					packagingDetails?.primary_share_your_pwn_epr_registration,
				primary_share_your_plastic_packaging_supplier_pwm_epr_registration_number:
					packagingDetails?.primary_share_your_plastic_packaging_supplier_pwm_epr_registration_number,
				primary_are_you_complying_with_the_pwm_epr_labeling_requirement:
					packagingDetails?.primary_are_you_complying_with_the_pwm_epr_labeling_requirement,
				primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement:
					packagingDetails?.primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement,
				primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement:
					packagingDetails?.primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement,
				primary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts:
					packagingDetails?.primary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts,
				primary_remarks_other_details:
					packagingDetails?.primary_remarks_other_details,
				secondary_density: packagingDetails?.secondary_density,
				secondary_packaging_strategy:
					packagingDetails?.secondary_packaging_strategy,
				secondary_carton_code: packagingDetails?.secondary_carton_code,
				secondary_carton_type: packagingDetails?.secondary_carton_type,
				secondary_packaging_material_type:
					packagingDetails?.secondary_packaging_material_type,
				secondary_securement_type: packagingDetails?.secondary_securement_type,
				secondary_total_loaded: packagingDetails?.secondary_total_loaded,
				secondary_outside_dimension:
					packagingDetails?.secondary_outside_dimension,
				secondary_dunnage_description:
					packagingDetails?.secondary_dunnage_description,
				secondary_labels: packagingDetails?.secondary_labels,
				secondary_container_ownership:
					packagingDetails?.secondary_container_ownership,
				secondary_type_of_plastic_packaging_supplied_along_with_Parts:
					packagingDetails?.secondary_type_of_plastic_packaging_supplied_along_with_Parts,
				secondary_is_the_packaging_collected_and_taken_back_by_supplier:
					select
						?.secondary_is_the_packaging_collected_and_taken_back_by_supplier
						?.value,
				secondary_are_you_complying_to_pwm_epr_rules:
					packagingDetails?.secondary_are_you_complying_to_pwm_epr_rules,
				secondary_share_your_pwn_epr_registration:
					packagingDetails?.secondary_share_your_pwn_epr_registration,
				secondary_share_your_plastic_packaging_supplier_pwm_epr_registration_number:
					packagingDetails?.secondary_share_your_plastic_packaging_supplier_pwm_epr_registration_number,
				secondary_are_you_complying_with_the_pwm_epr_labeling_requirement:
					packagingDetails?.secondary_are_you_complying_with_the_pwm_epr_labeling_requirement,
				secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement:
					packagingDetails?.secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement,
				secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement:
					packagingDetails?.secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement,
				secondary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts:
					packagingDetails?.secondary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts,
				secondary_remarks_other_details:
					packagingDetails?.secondary_remarks_other_details,
				transportation_mode: packagingDetails?.transportation_mode,
				pallet_dimensions: packagingDetails?.pallet_dimensions,
				no_of_pallets_per_vehicle: packagingDetails?.no_of_pallets_per_vehicle,
				stackable_non_stackable: packagingDetails?.stackable_non_stackable,
				sec_packaging_per_transit_modes:
					packagingDetails?.sec_packaging_per_transit_modes,
				no_of_pry_packs_per_sec_packs:
					packagingDetails?.no_of_pry_packs_per_sec_packs,
				inco_term: packagingDetails?.inco_term,
				hazardous_material_class: packagingDetails?.hazardous_material_class,
				loop_size: packagingDetails?.loop_size,
				life_of_returnable_packaging:
					packagingDetails?.life_of_returnable_packaging,
				unloading_loading_responsibility:
					packagingDetails?.unloading_loading_responsibility,
				supply_at_tml: packagingDetails?.supply_at_tml,
				theoretical_cubic_utilisation:
					packagingDetails?.theoretical_cubic_utilisation,
				remarks: packagingDetails?.remarks,
				//packaging_person: packagingDetails?.packaging_person,
				//purchasing_buyer_tml: packagingDetails?.purchasing_buyer_tml,
				//scm_tml: packagingDetails?.scm_tml,
				//packaging_person_date: convertUTCtoISTInYMD(packagingDetails?.packaging_person_date),
				//purchasing_buyer_tml_date: convertUTCtoISTInYMD(packagingDetails?.purchasing_buyer_tml_date),
				//scm_tml_date: convertUTCtoISTInYMD(packagingDetails?.scm_tml_date),
				tata_motors_receiving_location:
					packagingDetails?.tata_motors_receiving_location,
				tml_part_no: packagingDetails?.tml_part_no,
				tml_part_description: packagingDetails?.tml_part_description,
				part_weight: packagingDetails?.part_weight,
				part_dimensions: packagingDetails?.part_dimensions,
				annual_volume: packagingDetails?.annual_volume,
				no_of_parts_per_vehicle: packagingDetails?.no_of_parts_per_vehicle,
				packaging_cost: packagingDetails?.packaging_cost,
				transportation_cost: packagingDetails?.transportation_cost,
				models_applicable: packagingDetails?.models_applicable,
				part_only_image: isUploaded.part_only_image
					? packagingDetails?.part_only_image
					: '',
				part_dunnage_primary_packaging_image:
					isUploaded.part_dunnage_primary_packaging_image
						? packagingDetails?.part_dunnage_primary_packaging_image
						: '',
				primary_plus_secondary_packaging_image:
					isUploaded.primary_plus_secondary_packaging_image
						? packagingDetails?.primary_plus_secondary_packaging_image
						: '',
				user_name: user?.name,
				selected_plant_id: select.selected_plant_id?.value,
				assigned_approver_id: select?.selected_dmp_user_details?.value,
				commodity_type_id: select?.selected_commodity_type_details?.value,
				//approval_type: packagingDetails?.approval_type,
				//approval_status: packagingDetails?.approval_status,
				//approval_type_date: convertUTCtoISTInYMD(packagingDetails?.approval_type_date),
				is_updated: isEdited,
				excel_file_name: packagingDetails?.excel_attachment,
			},

			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res?.data?.status === 201) {
					setModalIsOpen(true);
					setTitle(res?.data?.message || 'Success');
					
					uploadExcelFile(res?.data?.result?.presigned_url_for_add, excelfile[0]);
				} else {
					// Handle unexpected success responses
					setTitle('Unexpected response format');
				}
				navigate('/packaging-strategy');
			},
			onFailure: (res) => {
				const status = res?.response?.data?.status || 'Unknown Error';
				const message = res?.message || 'Error occurred';
				setIsErrorModalOpen(true);
				setStatusCode(status);
				setTitle(message);
				setexcelfile([]);
			},
			errorCall: (res) => {
				const status = res?.response?.data?.status || 'Unknown Error';
				const message =
					res?.response?.data?.message || res?.message || 'An error occurred';
				setIsErrorModalOpen(true);
				setStatusCode(status);
				setTitle(message);
				setexcelfile([]); 
			},
		});
	};

	const darftForm = () => {
		baseApiCall({
			url: packaging_strategy_all_endpoints.POST_DRAFT_NEW_STRATEGY,
			requestBody: {
				company_name: packagingDetails?.company_name,
				company_address: packagingDetails?.company_address,
				pkg_person_contact_name: packagingDetails?.pkg_person_contact_name,
				email: packagingDetails?.email,
				vendor_code: packagingDetails?.vendor_code,
				state: packagingDetails?.state,
				tel_no: packagingDetails?.tel_no,
				fax_no: packagingDetails?.fax_no,
				primary_density: packagingDetails?.primary_density,
				primary_packaging_strategy:
					packagingDetails?.primary_packaging_strategy,
				primary_carton_code: packagingDetails?.primary_carton_code,
				primary_carton_type: packagingDetails?.primary_carton_type,
				primary_packaging_material_type:
					packagingDetails?.primary_packaging_material_type,
				primary_securement_type: packagingDetails?.primary_securement_type,
				primary_total_loaded: packagingDetails?.primary_total_loaded,
				primary_outside_dimension: packagingDetails?.primary_outside_dimension,
				primary_dunnage_description:
					packagingDetails?.primary_dunnage_description,
				primary_labels: packagingDetails?.primary_labels,
				primary_container_ownership:
					packagingDetails?.primary_container_ownership,
				primary_type_of_plastic_packaging_supplied_along_with_Parts:
					packagingDetails?.primary_type_of_plastic_packaging_supplied_along_with_Parts,
				primary_is_the_packaging_collected_and_taken_back_by_supplier: select
					?.primary_is_the_packaging_collected_and_taken_back_by_supplier?.value
					? select
							?.primary_is_the_packaging_collected_and_taken_back_by_supplier
							?.value
					: '',
				primary_are_you_complying_to_pwm_epr_rules:
					packagingDetails?.primary_are_you_complying_to_pwm_epr_rules,
				primary_share_your_pwn_epr_registration:
					packagingDetails?.primary_share_your_pwn_epr_registration,
				primary_share_your_plastic_packaging_supplier_pwm_epr_registration_number:
					packagingDetails?.primary_share_your_plastic_packaging_supplier_pwm_epr_registration_number,
				primary_are_you_complying_with_the_pwm_epr_labeling_requirement:
					packagingDetails?.primary_are_you_complying_with_the_pwm_epr_labeling_requirement,
				primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement:
					packagingDetails?.primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement,
				primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement:
					packagingDetails?.primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement,
				primary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts:
					packagingDetails?.primary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts,
				primary_remarks_other_details:
					packagingDetails?.primary_remarks_other_details,
				secondary_density: packagingDetails?.secondary_density,
				secondary_packaging_strategy:
					packagingDetails?.secondary_packaging_strategy,
				secondary_carton_code: packagingDetails?.secondary_carton_code,
				secondary_carton_type: packagingDetails?.secondary_carton_type,
				secondary_packaging_material_type:
					packagingDetails?.secondary_packaging_material_type,
				secondary_securement_type: packagingDetails?.secondary_securement_type,
				secondary_total_loaded: packagingDetails?.secondary_total_loaded,
				secondary_outside_dimension:
					packagingDetails?.secondary_outside_dimension,
				secondary_dunnage_description:
					packagingDetails?.secondary_dunnage_description,
				secondary_labels: packagingDetails?.secondary_labels,
				secondary_container_ownership:
					packagingDetails?.secondary_container_ownership,
				secondary_type_of_plastic_packaging_supplied_along_with_Parts:
					packagingDetails?.secondary_type_of_plastic_packaging_supplied_along_with_Parts,
				secondary_is_the_packaging_collected_and_taken_back_by_supplier: select
					?.secondary_is_the_packaging_collected_and_taken_back_by_supplier
					?.value
					? select
							?.secondary_is_the_packaging_collected_and_taken_back_by_supplier
							?.value
					: '',
				secondary_are_you_complying_to_pwm_epr_rules:
					packagingDetails?.secondary_are_you_complying_to_pwm_epr_rules,
				secondary_share_your_pwn_epr_registration:
					packagingDetails?.secondary_share_your_pwn_epr_registration,
				secondary_share_your_plastic_packaging_supplier_pwm_epr_registration_number:
					packagingDetails?.secondary_share_your_plastic_packaging_supplier_pwm_epr_registration_number,
				secondary_are_you_complying_with_the_pwm_epr_labeling_requirement:
					packagingDetails?.secondary_are_you_complying_with_the_pwm_epr_labeling_requirement,
				secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement:
					packagingDetails?.secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement,
				secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement:
					packagingDetails?.secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement,
				secondary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts:
					packagingDetails?.secondary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts,
				secondary_remarks_other_details:
					packagingDetails?.secondary_remarks_other_details,
				transportation_mode: packagingDetails?.transportation_mode,
				pallet_dimensions: packagingDetails?.pallet_dimensions,
				no_of_pallets_per_vehicle: packagingDetails?.no_of_pallets_per_vehicle,
				stackable_non_stackable: packagingDetails?.stackable_non_stackable,
				sec_packaging_per_transit_modes:
					packagingDetails?.sec_packaging_per_transit_modes,
				no_of_pry_packs_per_sec_packs:
					packagingDetails?.no_of_pry_packs_per_sec_packs,
				inco_term: packagingDetails?.inco_term,
				hazardous_material_class: packagingDetails?.hazardous_material_class,
				loop_size: packagingDetails?.loop_size,
				life_of_returnable_packaging:
					packagingDetails?.life_of_returnable_packaging,
				unloading_loading_responsibility:
					packagingDetails?.unloading_loading_responsibility,
				supply_at_tml: packagingDetails?.supply_at_tml,
				theoretical_cubic_utilisation:
					packagingDetails?.theoretical_cubic_utilisation,
				remarks: packagingDetails?.remarks,
				tata_motors_receiving_location:
					packagingDetails?.tata_motors_receiving_location,
				tml_part_no: packagingDetails?.tml_part_no,
				tml_part_description: packagingDetails?.tml_part_description,
				part_weight: packagingDetails?.part_weight,
				part_dimensions: packagingDetails?.part_dimensions,
				annual_volume: packagingDetails?.annual_volume,
				no_of_parts_per_vehicle: packagingDetails?.no_of_parts_per_vehicle,
				packaging_cost: packagingDetails?.packaging_cost,
				transportation_cost: packagingDetails?.transportation_cost,
				models_applicable: packagingDetails?.models_applicable,
				part_only_image: isUploaded.part_only_image
					? packagingDetails?.part_only_image
					: '',
				part_dunnage_primary_packaging_image:
					isUploaded.part_dunnage_primary_packaging_image
						? packagingDetails?.part_dunnage_primary_packaging_image
						: '',
				primary_plus_secondary_packaging_image:
					isUploaded.primary_plus_secondary_packaging_image
						? packagingDetails?.primary_plus_secondary_packaging_image
						: '',
				user_name: user?.name,
				selected_plant_id: select?.selected_plant_id?.value
					? select?.selected_plant_id?.value
					: '',
				assigned_approver_id: select?.selected_dmp_user_details?.value,
				commodity_type_id: select?.selected_commodity_type_details?.value,
				drafted_strategy_id: drafteddata?.Strategies_table?.id,
			},

			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res?.data?.status === 201) {
					setModalIsOpen(true);
					setTitle(res?.data?.message || 'Success');
					setIsButtonDisabled(true);
				} else {
					// Handle unexpected success responses
					setTitle('Unexpected response format');
				}
				// navigate('/packaging-strategy');
			},
			onFailure: (res) => {
				const status = res?.response?.data?.status || 'Unknown Error';
				const message = res?.message || 'Error occurred';
				setIsErrorModalOpen(true);
				setStatusCode(status);
				setTitle(message);
			},
			errorCall: (res) => {
				const status = res?.response?.data?.status || 'Unknown Error';
				const message =
					res?.response?.data?.message || res?.message || 'An error occurred';
				setIsErrorModalOpen(true);
				setStatusCode(status);
				setTitle(message);
			},
		});
	};

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const formValid = useCallback(() => {
		const errorFields = [];
		const tempMissingRecommendedFields = [];

		// Determine if primary or secondary is 'Yes'
		const primaryIsYes =
			select?.primary_is_the_packaging_collected_and_taken_back_by_supplier
				?.value === 'Yes';
		const secondaryIsYes =
			select?.secondary_is_the_packaging_collected_and_taken_back_by_supplier
				?.value === 'Yes';

		// Create final required fields based on conditions
		const finalRequiredFields = [
			...requiredFields,
			...(primaryIsYes ? [] : primaryRequiredFields),
			...(secondaryIsYes ? [] : secondaryRequiredFields),
		];

		// Check for fields with error messages and missing fields
		const missingFields = finalRequiredFields?.filter((field) => {
			if (errorMessage[field]) {
				errorFields.push(field); // Collect error fields
				return false; // Exclude from missingFields
			}
			return !packagingDetails[field]; // Include missing fields
		});

		// Check for missing recommended fields only if the user has not acknowledged the warning
		if (!recommendedWarningAcknowledged) {
			recommendedFields?.forEach((field) => {
				if (!packagingDetails[field]) {
					tempMissingRecommendedFields.push(field); // Collect missing recommended fields
				}
			});

			// Handle missing recommended fields
			if (tempMissingRecommendedFields?.length > 0) {
				setMissingRecommendedFields(tempMissingRecommendedFields);
				// Stop form submission for now
			} else {
				setMissingRecommendedFields([]); // Clear missing recommended fields if none are found
			}
		}

		// Check validity of dropdowns
		const isDropdownsValid =
			!!select.selected_plant_id?.value &&
			!!select.selected_dmp_user_details?.value &&
			!!select.selected_commodity_type_details?.value;

		// Determine final validity state
		const hasErrorMessages = errorFields.length > 0;
		const hasAllFields = missingFields.length === 0;

		return hasAllFields && !hasErrorMessages && isDropdownsValid;
	}, [packagingDetails, errorMessage, select]);

	const handleAssigneeValue = async (value, name) => {
		setSelect((prev) => {
			switch (name) {
				case 'selected_plant':
					// Reset only dependent fields upon a plant change
					return {
						...prev,
						selected_plant_id: value,
						selected_commodity_type_details: null,  // Reset commodity type when plant changes
						selected_dmp_user_details: null         // Reset DMP user when plant changes
					};
				case 'selected_commodity_type_details':
					// Set the commodity type directly without resetting it
					return {
						...prev,
						selected_commodity_type_details: value,
						selected_dmp_user_details: null         // Reset DMP user when commodity type changes
					};
				case 'selected_dmp_user_details':
					// Set the DMP user directly
					return {
						...prev,
						selected_dmp_user_details: value
					};
				default:
					return prev;
			}
		});
		setIsButtonDisabled(false);
	};

	const handleFileChange = (event) => {
		event.preventDefault();
		const { name, files } = event?.target; // `name` helps to identify the field
		const file = files[0];

		// Check if file is an image or Excel
		const isImageFile = file && file?.type?.startsWith('image/');
		const isExcelFile = file && (file?.type?.includes('excel') || file?.type?.includes('spreadsheetml'));

		// Handle file state updates
		setisUploaded((prev) => ({
			...prev,
			[name]: true,
		}));

		if (file && isImageFile) {
			const reader = new FileReader();

			// Image file: Convert it to base64 and update details
			reader.onloadend = () => {
				let base64String = reader.result;

				// Remove data URL prefix (e.g., "data:image/png;base64,")
				base64String = base64String.replace(/^data:image\/[a-z]+;base64,/, '');

				// Set the image data (for preview and upload) in state
				setPackagingDetails((prev) => ({
					...prev,
					[name]: base64String,
					[`${name}_preview`]: URL.createObjectURL(file), // Dynamically assign value based on the input's name attribute
				}));
			};

			reader.readAsDataURL(file); // Convert image to base64
		} else if (file && isExcelFile) {
			// Set the image data (for preview and upload) in state
			setPackagingDetails((prev) => ({
				...prev,
				[name]: file?.name,
			}));

			const selectedFiles = [...files];
			let exceededFiles = [];
			const maxSize = 10000000; //10MB

			// Call the function to store the Excel file
			const validFiles = selectedFiles?.filter((file) => {
				if (file?.size <= maxSize) {
					return true;
				} else {
					exceededFiles.push(file);
					return false;
				}
			});

			if (exceededFiles?.length > 0) {
				exceededFiles?.map((fileName) => {
					dispatch(
						onResponse({
							isToaster: true,
							severity: commonVaribles.error,
							message: `${fileName.name} Size Limit Exceeds`,
						})
					);
				});
			}

			const validExcelFiles = validFiles?.filter((excel) =>
				/\.(xlsx|xlsm|xls)$/i.test(excel.name)
			);
			const invalidExcelFiles = validFiles?.filter(
				(excel) => !validExcelFiles?.includes(excel)
			);

			if (invalidExcelFiles?.length > 0) {
				setErrorMessage(commonVaribles?.excelErrormsg);
			} else {
				setErrorMessage('');
			}
			setexcelfile(validExcelFiles);
		}
		setIsButtonDisabled(false);
	};

	const handleWarningAcknowledgement = () => {
		setRecommendedWarningAcknowledged(true); // User acknowledges warning
		setIsConfirmationModalOpen(false); // Close the modal
		submitForm(); // Re-attempt form submission
	};

	useEffect(() => {
		setIsButtonDisable(!formValid());
	}, [formValid]);

	const setSelectOption = (event, name) => {
		setSelect((prevState) => ({ ...prevState, [name]: event }));

		switch (name) {
			case 'primary_is_the_packaging_collected_and_taken_back_by_supplier':
				if (event?.value == 'Yes') {
					setPackagingDetails((prevState) => ({
						...prevState,
						primary_are_you_complying_to_pwm_epr_rules: null,
						primary_share_your_pwn_epr_registration: null,
						primary_share_your_plastic_packaging_supplier_pwm_epr_registration_number:
							null,
						primary_are_you_complying_with_the_pwm_epr_labeling_requirement:
							null,
						primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement:
							null,
						primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement:
							null,
						primary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts:
							null,
						primary_remarks_other_details: null,
					}));
					setErrorMessage((prev) => ({
						...prev,
						primary_are_you_complying_to_pwm_epr_rules: false,
						primary_share_your_pwn_epr_registration: false,
						primary_share_your_plastic_packaging_supplier_pwm_epr_registration_number: false,
						primary_are_you_complying_with_the_pwm_epr_labeling_requirement: false,
						primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement: false,
						primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement: false,
						primary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts: false,
						primary_remarks_other_details: false,
					}));
				}
				break;
			case 'secondary_is_the_packaging_collected_and_taken_back_by_supplier':
				if (event?.value == 'Yes') {
					setPackagingDetails((prevState) => ({
						...prevState,
						secondary_are_you_complying_to_pwm_epr_rules: null,
						secondary_share_your_pwn_epr_registration: null,
						secondary_share_your_plastic_packaging_supplier_pwm_epr_registration_number:
							null,
						secondary_are_you_complying_with_the_pwm_epr_labeling_requirement:
							null,
						secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement:
							null,
						secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement:
							null,
						secondary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts:
							null,
						secondary_remarks_other_details: null,
					}));

					setErrorMessage((prev) => ({
						...prev,
						secondary_are_you_complying_to_pwm_epr_rules: false,
						secondary_share_your_pwn_epr_registration: false,
						secondary_share_your_plastic_packaging_supplier_pwm_epr_registration_number: false,
						secondary_are_you_complying_with_the_pwm_epr_labeling_requirement: false,
						secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement: false,
						secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement: false,
						secondary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts: false,
						secondary_remarks_other_details: false,
					}));
				}
				break;
			default:
				break;
		}
		setPackagingDetails((prevState) => ({
			...prevState,
			[name]: event.value,
		}));
		setIsButtonDisabled(false);
	};

	const renderGuidelinesTable = (data) => {
		return (
			<div className={styles.guideTable}>
				{data.map((row, rowIndex) => (
					<div
						key={rowIndex}
						className={clsx(
							styles.guideTableRow,
							rowIndex === 0 ? styles.guideTableHeader : styles.guideTableData
						)}
					>
						{row.map((cell, cellIndex) => (
							<div key={cellIndex} className={styles.guideTableCell}>
								{cell}
							</div>
						))}
					</div>
				))}
			</div>
		);
	};

	return (
		<div className={styles['add-user-form']}>
			<div className={globalstyle['breadcrumb']}>
				<BackButton
					basePath={Title.packaging_strategy}
					action={headerTitleName}
					handleClick={() => {
						navigate('/packaging-strategy');
					}}
					browserBack={true}
				/>
			</div>
			<div>
				<CustomTab title={headerTitleName} withOutCount withOutFilters={true} />
			</div>
			<div className={styles['form-group']}>
				<div className={styles['user-form']}>
					<div className={styles['subSection']}>
						<div className={styles['form-head']}>
							<span>Supplier Information (Shipping)</span>
						</div>
						<form className={styles['form-body']}>
							{/* Company Name */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>Company Name*</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.company_name}
										name="company_name"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.company_name && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForCompanyName}
										</span>
									)}
								</div>
							</div>

							{/* Company Address */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>Company Address*</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.company_address}
										name="company_address"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.company_address && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForCompanyAddress}
										</span>
									)}
								</div>
							</div>

							{/* Contact Person Name */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Pkg Person Contact Name*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.pkg_person_contact_name}
										name="pkg_person_contact_name"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.pkg_person_contact_name && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPkgPersonContactName}
										</span>
									)}
								</div>
							</div>

							{/* Email */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>Email*</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.email}
										name="email"
										type="email"
										onChange={handleDataChange}
									/>
									{errorMessage.email && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForEmail}
										</span>
									)}
								</div>
							</div>

							{/* Vendor Code */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>Vendor Code*</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.vendor_code}
										name="vendor_code"
										type="text"
										onChange={handleDataChange}
										disabled={isEdited}
									/>
									{errorMessage.vendor_code && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForVendorCode}
										</span>
									)}
								</div>
							</div>

							{/* State */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>State, Country*</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.state}
										name="state"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.state && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForState}
										</span>
									)}
								</div>
							</div>

							{/* Telephone Number */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Telephone Number*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.tel_no}
										name="tel_no"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.tel_no && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForTelNo}
										</span>
									)}
								</div>
							</div>

							{/* Fax Number */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>Fax Number*</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.fax_no}
										name="fax_no"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.fax_no && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForFaxNo}
										</span>
									)}
								</div>
							</div>

							{/* Approval Type */}
							{/* <div className={styles['form-data']}>
								<label className={styles['form-label']}>Approval Type*</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.approval_type}
										name="approval_type"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.approval_type && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForApprovalType}
										</span>
									)}
								</div>
							</div> */}

							{/* Approval Status */}
							{/* <div className={styles['form-data']}>
								<label className={styles['form-label']}>Status*</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.approval_status}
										name="approval_status"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.approval_status && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForApprovalStatus}
										</span>
									)}
								</div>
							</div> */}

							{/* Approval Type Date */}
							{/* <div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Date of Approval*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['date-field']}
										value={packagingDetails.approval_type_date}
										name="approval_type_date"
										type="date"
										onChange={handleDataChange}
									/>
									{errorMessage.approval_type_date && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForApprovalTypeDate}
										</span>
									)}
								</div>
							</div> */}
						</form>
					</div>
					<div className={styles['subSection']}>
						<div className={styles['form-head']}>
							<span>PROGRAM AND PART INFORMATION (TMPVL/ TPEM)</span>
						</div>
						<form className={styles['form-body']}>
							{/* Tata Motors Receiving Location */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Tata Motors Receiving Location*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.tata_motors_receiving_location}
										name="tata_motors_receiving_location"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.tata_motors_receiving_location && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForTataMotorsReceivingLocation}
										</span>
									)}
								</div>
							</div>

							{/* TML Part No */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>Part No*</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.tml_part_no}
										name="tml_part_no"
										type="text"
										onChange={handleDataChange}
										disabled={isEdited}
									/>
									{errorMessage.tml_part_no && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForTMLPartNo}
										</span>
									)}
								</div>
							</div>

							{/* TML Part Description */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Part Description*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.tml_part_description}
										name="tml_part_description"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.tml_part_description && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForTMLPartDescription}
										</span>
									)}
								</div>
							</div>

							{/* Part Weight */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Part Weight (Kg)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.part_weight}
										name="part_weight"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.part_weight && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPartWeight}
										</span>
									)}
								</div>
							</div>

							{/* Part Dimensions */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Part Dimensions (L X W X H) (mm)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.part_dimensions}
										name="part_dimensions"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.part_dimensions && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPartDimensions}
										</span>
									)}
								</div>
							</div>

							{/* Annual Volume */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Annual Volume (Projected)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.annual_volume}
										name="annual_volume"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.annual_volume && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForAnnualVolume}
										</span>
									)}
								</div>
							</div>

							{/* Number of Parts per Vehicle */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Number of Parts per Vehicle*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.no_of_parts_per_vehicle}
										name="no_of_parts_per_vehicle"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.no_of_parts_per_vehicle && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForNoOfPartsPerVehicle}
										</span>
									)}
								</div>
							</div>

							{/* Models Applicable */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Models Applicable*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.models_applicable}
										name="models_applicable"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.models_applicable && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForModelsApplicable}
										</span>
									)}
								</div>
							</div>

							{/* Packaging Cost */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Packaging Cost / Part*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.packaging_cost}
										name="packaging_cost"
										type="number"
										onChange={handleDataChange}
									/>
									{errorMessage.packaging_cost && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPackagingCost}
										</span>
									)}
								</div>
							</div>

							{/* Transportation Cost */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Transportation Cost / Part*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.transportation_cost}
										name="transportation_cost"
										type="number"
										onChange={handleDataChange}
									/>
									{errorMessage.transportation_cost && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForTransportationCost}
										</span>
									)}
								</div>
							</div>
						</form>
					</div>
					<div className={styles['subSection']}>
						<div className={styles['form-head']}>
							<span>VISUAL REFERENCES ( Part & Packaging)</span>
						</div>
						<div className={styles['form-body']}>
							{/* Part Only Image */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>Part Only*</label>
								<div className={styles['user-group']}>
									{/* Preview Image */}
									<FileInputSection
										name="part_only_image"
										onChange={handleFileChange}
										//setDetails={setPackagingDetails}
										editName={'Part Only Image'}
										isEdited={isEdited || isDrafted}
										fileURL={(reuploadeddata ? reuploadeddata : drafteddata)?.Strategies_table?.visual_reference?.part_only_image}
										acceptTypes="image/*" // Accept only image files
									/>
								</div>
							</div>

							{/* Part Dunnage Primary Packaging Image */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Part + Dunnage + Primary Packaging*
								</label>
								<div className={styles['user-group']}>
									<FileInputSection
										name="part_dunnage_primary_packaging_image"
										onChange={handleFileChange}
										//setDetails={setPackagingDetails}
										editName={'Part + Dunnage + Primary Packaging Image'}
										isEdited={isEdited || isDrafted}
										fileURL={
											(reuploadeddata ? reuploadeddata : drafteddata)?.Strategies_table?.visual_reference
											?.part_dunnage_primary_packaging_image
										}
										acceptTypes="image/*" // Accept only image files
									/>
								</div>
							</div>

							{/* Primary Plus Secondary Packaging Image */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Primary + Secondary Packaging*
								</label>
								<div className={styles['user-group']}>
									<FileInputSection
										name="primary_plus_secondary_packaging_image"
										onChange={handleFileChange}
										//setDetails={setPackagingDetails}
										editName={'Primary + Secondary Packaging Image'}
										isEdited={isEdited || isDrafted}
										fileURL={
											(reuploadeddata ? reuploadeddata : drafteddata)?.Strategies_table?.visual_reference
												?.primary_plus_secondary_packaging_image
										}
										acceptTypes="image/*" // Accept only image files
									/>
								</div>
							</div>
						</div>
					</div>
					<div className={styles['subSection']}>
						<div className={styles['form-head']}>
							<span>Primary Packaging Information</span>
						</div>
						<form className={styles['form-body']}>
							{/* Primary Density */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Density (Qty of parts)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.primary_density}
										name="primary_density"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.primary_density && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPrimaryDensity}
										</span>
									)}
								</div>
							</div>

							{/* Primary Packaging Strategy */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Packaging Strategy*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.primary_packaging_strategy}
										name="primary_packaging_strategy"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.primary_packaging_strategy && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPrimaryPackagingStrategy}
										</span>
									)}
								</div>
							</div>

							{/* Primary Carton Code */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>Carton Code*</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.primary_carton_code}
										name="primary_carton_code"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.primary_carton_code && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPrimaryCartonCode}
										</span>
									)}
								</div>
							</div>

							{/* Primary Carton Type */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Carton Type (Design)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.primary_carton_type}
										name="primary_carton_type"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.primary_carton_type && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPrimaryCartonType}
										</span>
									)}
								</div>
							</div>

							{/* Primary Packaging Material Type */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Packaging Material Type*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.primary_packaging_material_type}
										name="primary_packaging_material_type"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.primary_packaging_material_type && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPrimaryPackagingMaterialType}
										</span>
									)}
								</div>
							</div>

							{/* Primary Securement Type */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Securement / Closure Type*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.primary_securement_type}
										name="primary_securement_type"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.primary_securement_type && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPrimarySecurementType}
										</span>
									)}
								</div>
							</div>

							{/* Primary Total Loaded */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Total Loaded Wt. (Kg - Full)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.primary_total_loaded}
										name="primary_total_loaded"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.primary_total_loaded && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPrimaryTotalLoaded}
										</span>
									)}
								</div>
							</div>

							{/* Primary Outside Dimension */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Outside Dimension (LXWXH) (mm)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.primary_outside_dimension}
										name="primary_outside_dimension"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.primary_outside_dimension && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPrimaryOutsideDimension}
										</span>
									)}
								</div>
							</div>

							{/* Primary Dunnage Description */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Dunnage & Description*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.primary_dunnage_description}
										name="primary_dunnage_description"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.primary_dunnage_description && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPrimaryDunnageDescription}
										</span>
									)}
								</div>
							</div>

							{/* Primary Labels */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Labels (Quantity / Location)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.primary_labels}
										name="primary_labels"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.primary_labels && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPrimaryLabels}
										</span>
									)}
								</div>
							</div>

							{/* Primary Container Ownership */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Container Ownership*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.primary_container_ownership}
										name="primary_container_ownership"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.primary_container_ownership && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPrimaryContainerOwnership}
										</span>
									)}
								</div>
							</div>

							{/* Primary Type of Plastic Packaging Supplied Along With Parts */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Type of Plastic Packaging Supplied Along With Parts*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={
											packagingDetails.primary_type_of_plastic_packaging_supplied_along_with_Parts
										}
										name="primary_type_of_plastic_packaging_supplied_along_with_Parts"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.primary_type_of_plastic_packaging_supplied_along_with_Parts && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPrimaryPlasticPackagingSupplied}
										</span>
									)}
								</div>
							</div>

							{/* Primary Is the Packaging Collected and Taken Back by Supplier */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Is the Packaging Collected and Taken Back by Supplier?*
								</label>
								<div className={styles['user-group']}>
									<Select
										className={styles['input-box']}
										//styles={customStyle}
										options={complyingOptions}
										value={
											select[
												'primary_is_the_packaging_collected_and_taken_back_by_supplier'
											]
										}
										isSearchable={false}
										onChange={(e) =>
											setSelectOption(
												e,
												'primary_is_the_packaging_collected_and_taken_back_by_supplier'
											)
										}
									/>
									{errorMessage.primary_is_the_packaging_collected_and_taken_back_by_supplier && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPrimaryPackagingCollected}
										</span>
									)}
								</div>
							</div>
							{select
								?.primary_is_the_packaging_collected_and_taken_back_by_supplier
								?.value === 'No' && (
								<>
									{/* Primary Are You Complying to PWM EPR Rules */}
									<div className={styles['form-data']}>
										<label className={styles['form-label']}>
											Are you complying to PWM EPR Rules (Plastic Waste
											Management) ?*
										</label>
										<div className={styles['user-group']}>
											<input
												className={styles['text-box']}
												value={
													packagingDetails.primary_are_you_complying_to_pwm_epr_rules
												}
												name="primary_are_you_complying_to_pwm_epr_rules"
												type="text"
												onChange={handleDataChange}
											/>
											{errorMessage.primary_are_you_complying_to_pwm_epr_rules && (
												<span className={styles['errormsg']}>
													{errorMsg.errorMsgForPrimaryComplianceToPWM}
												</span>
											)}
										</div>
									</div>

									{/* Primary Share Your PWM EPR Registration */}
									<div className={styles['form-data']}>
										<label className={styles['form-label']}>
											Share your PWM EPR Registration No. (As a brand owner)*
										</label>
										<div className={styles['user-group']}>
											<input
												className={styles['text-box']}
												value={
													packagingDetails.primary_share_your_pwn_epr_registration
												}
												name="primary_share_your_pwn_epr_registration"
												type="text"
												onChange={handleDataChange}
											/>
											{errorMessage.primary_share_your_pwn_epr_registration && (
												<span className={styles['errormsg']}>
													{errorMsg.errorMsgForPrimaryPWNRegistration}
												</span>
											)}
										</div>
									</div>

									{/* Primary Share Your Plastic Packaging Supplier PWM EPR Registration Number */}
									<div className={styles['form-data']}>
										<label className={styles['form-label']}>
											Share your plastic packaging supplier PWM EPR Registration
											Number (As a producer/manufacturer) ?*
										</label>
										<div className={styles['user-group']}>
											<input
												className={styles['text-box']}
												value={
													packagingDetails.primary_share_your_plastic_packaging_supplier_pwm_epr_registration_number
												}
												name="primary_share_your_plastic_packaging_supplier_pwm_epr_registration_number"
												type="text"
												onChange={handleDataChange}
											/>
											{errorMessage.primary_share_your_plastic_packaging_supplier_pwm_epr_registration_number && (
												<span className={styles['errormsg']}>
													{
														errorMsg.errorMsgForPrimarySupplierRegistrationNumber
													}
												</span>
											)}
										</div>
									</div>

									{/* Primary Are You Complying With the PWM EPR Labeling Requirement */}
									<div className={styles['form-data']}>
										<label className={styles['form-label']}>
											Are you complying with the PWM EPR Labeling Requirement?*
										</label>
										<div className={styles['user-group']}>
											<input
												className={styles['text-box']}
												value={
													packagingDetails.primary_are_you_complying_with_the_pwm_epr_labeling_requirement
												}
												name="primary_are_you_complying_with_the_pwm_epr_labeling_requirement"
												type="text"
												onChange={handleDataChange}
											/>
											{errorMessage.primary_are_you_complying_with_the_pwm_epr_labeling_requirement && (
												<span className={styles['errormsg']}>
													{errorMsg.errorMsgForPrimaryLabelingRequirement}
												</span>
											)}
										</div>
									</div>

									{/* Primary Are You Complying With the PWM EPR Plastic Packaging Recycling Requirement */}
									<div className={styles['form-data']}>
										<label className={styles['form-label']}>
											Are You Complying With the PWM EPR Plastic Packaging
											Recycling Requirement?*
										</label>
										<div className={styles['user-group']}>
											<input
												className={styles['text-box']}
												value={
													packagingDetails.primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement
												}
												name="primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement"
												type="text"
												onChange={handleDataChange}
											/>
											{errorMessage.primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement && (
												<span className={styles['errormsg']}>
													{errorMsg.errorMsgForPrimaryRecyclingRequirement}
												</span>
											)}
										</div>
									</div>

									{/* Primary Are You Complying With the PWM EPR Plastic Packaging Recycled Content Requirement */}
									<div className={styles['form-data']}>
										<label className={styles['form-label']}>
											Are You Complying With the PWM EPR Plastic Packaging
											Recycled Content Requirement?*
										</label>
										<div className={styles['user-group']}>
											<input
												className={styles['text-box']}
												value={
													packagingDetails.primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement
												}
												name="primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement"
												type="text"
												onChange={handleDataChange}
											/>
											{errorMessage.primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement && (
												<span className={styles['errormsg']}>
													{
														errorMsg.errorMsgForPrimaryRecycledContentRequirement
													}
												</span>
											)}
										</div>
									</div>

									{/* Primary What Is the Current Percent of Recycled Content in the Plastic Packaging of the Parts */}
									<div className={styles['form-data']}>
										<label className={styles['form-label']}>
											What is the current % of recycled content in the plastic
											packaging of the parts ?*
										</label>
										<div className={styles['user-group']}>
											<input
												className={styles['text-box']}
												value={
													packagingDetails.primary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts
												}
												name="primary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts"
												type="percentage"
												onChange={handleDataChange}
											/>
											{errorMessage.primary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts && (
												<span className={styles['errormsg']}>
													{errorMsg.errorMsgForPrimaryRecycledContentPercent}
												</span>
											)}
										</div>
									</div>

									{/* Primary Remarks Other Details */}
									<div className={styles['form-data']}>
										<label className={styles['form-label']}>
											Remarks/Any Other Details*
										</label>
										<div className={styles['user-group']}>
											<input
												className={styles['text-box']}
												value={packagingDetails.primary_remarks_other_details}
												name="primary_remarks_other_details"
												type="text"
												onChange={handleDataChange}
											/>
											{errorMessage.primary_remarks_other_details && (
												<span className={styles['errormsg']}>
													{errorMsg.errorMsgForPrimaryRemarks}
												</span>
											)}
										</div>
									</div>
								</>
							)}
						</form>
						<div className={styles.label}>
							For More Details, Visit the link: <a className={styles.value} href="https://eprplastic.cpcb.gov.in/#/plastic/home" target="_blank"> https://eprplastic.cpcb.gov.in/#/plastic/home </a>
						</div>
					</div>
					<div className={styles['subSection']}>
						<div className={styles['form-head']}>
							<span>Secondary Packaging Information</span>
						</div>
						<form className={styles['form-body']}>
							{/* Secondary Density */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Density (Qty of parts)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.secondary_density}
										name="secondary_density"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.secondary_density && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSecondaryDensity}
										</span>
									)}
								</div>
							</div>

							{/* Secondary Packaging Strategy */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Packaging Strategy*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.secondary_packaging_strategy}
										name="secondary_packaging_strategy"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.secondary_packaging_strategy && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSecondaryPackagingStrategy}
										</span>
									)}
								</div>
							</div>

							{/* Secondary Carton Code */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>Carton Code*</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.secondary_carton_code}
										name="secondary_carton_code"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.secondary_carton_code && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSecondaryCartonCode}
										</span>
									)}
								</div>
							</div>

							{/* Secondary Carton Type */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Carton Type (Design)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.secondary_carton_type}
										name="secondary_carton_type"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.secondary_carton_type && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSecondaryCartonType}
										</span>
									)}
								</div>
							</div>

							{/* Secondary Packaging Material Type */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Packaging Material Type*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.secondary_packaging_material_type}
										name="secondary_packaging_material_type"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.secondary_packaging_material_type && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSecondaryPackagingMaterialType}
										</span>
									)}
								</div>
							</div>

							{/* Secondary Securement Type */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Securement / Closure Type*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.secondary_securement_type}
										name="secondary_securement_type"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.secondary_securement_type && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSecondarySecurementType}
										</span>
									)}
								</div>
							</div>

							{/* Secondary Total Loaded */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Total Loaded Wt. (Kg - Full)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.secondary_total_loaded}
										name="secondary_total_loaded"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.secondary_total_loaded && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSecondaryTotalLoaded}
										</span>
									)}
								</div>
							</div>

							{/* Secondary Outside Dimension */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Outside Dimension (LXWXH) (mm)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.secondary_outside_dimension}
										name="secondary_outside_dimension"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.secondary_outside_dimension && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSecondaryOutsideDimension}
										</span>
									)}
								</div>
							</div>

							{/* Secondary Dunnage Description */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Dunnage & Description*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.secondary_dunnage_description}
										name="secondary_dunnage_description"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.secondary_dunnage_description && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSecondaryDunnageDescription}
										</span>
									)}
								</div>
							</div>

							{/* Secondary Labels */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Labels (Quantity / Location)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.secondary_labels}
										name="secondary_labels"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.secondary_labels && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSecondaryLabels}
										</span>
									)}
								</div>
							</div>

							{/* Secondary Container Ownership */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Container Ownership*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.secondary_container_ownership}
										name="secondary_container_ownership"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.secondary_container_ownership && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSecondaryContainerOwnership}
										</span>
									)}
								</div>
							</div>

							{/* Secondary Type of Plastic Packaging Supplied Along With Parts */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Type of Plastic Packaging Supplied Along With Parts*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={
											packagingDetails.secondary_type_of_plastic_packaging_supplied_along_with_Parts
										}
										name="secondary_type_of_plastic_packaging_supplied_along_with_Parts"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.secondary_type_of_plastic_packaging_supplied_along_with_Parts && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSecondaryPlasticPackagingSupplied}
										</span>
									)}
								</div>
							</div>

							{/* Secondary Is the Packaging Collected and Taken Back by Supplier */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Is the Packaging Collected and Taken Back by Supplier?*
								</label>
								<div className={styles['user-group']}>
									<Select
										className={styles['input-box']}
										//styles={customStyle}
										options={complyingOptions}
										value={
											select[
												'secondary_is_the_packaging_collected_and_taken_back_by_supplier'
											]
										}
										isSearchable={false}
										onChange={(e) =>
											setSelectOption(
												e,
												'secondary_is_the_packaging_collected_and_taken_back_by_supplier'
											)
										}
									/>
									{errorMessage.secondary_is_the_packaging_collected_and_taken_back_by_supplier && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSecondaryPackagingCollected}
										</span>
									)}
								</div>
							</div>

							{select
								?.secondary_is_the_packaging_collected_and_taken_back_by_supplier
								?.value === 'No' && (
								<>
									{/* Secondary Are You Complying to PWM EPR Rules */}
									<div className={styles['form-data']}>
										<label className={styles['form-label']}>
											Are you complying to PWM EPR Rules (Plastic Waste
											Management) ?*
										</label>
										<div className={styles['user-group']}>
											<input
												className={styles['text-box']}
												value={
													packagingDetails.secondary_are_you_complying_to_pwm_epr_rules
												}
												name="secondary_are_you_complying_to_pwm_epr_rules"
												type="text"
												onChange={handleDataChange}
											/>
											{errorMessage.secondary_are_you_complying_to_pwm_epr_rules && (
												<span className={styles['errormsg']}>
													{errorMsg.errorMsgForSecondaryComplianceToPWM}
												</span>
											)}
										</div>
									</div>

									{/* Secondary Share Your PWN EPR Registration */}
									<div className={styles['form-data']}>
										<label className={styles['form-label']}>
											Share your PWM EPR Registration No. (As a brand owner) ?*
										</label>
										<div className={styles['user-group']}>
											<input
												className={styles['text-box']}
												value={
													packagingDetails.secondary_share_your_pwn_epr_registration
												}
												name="secondary_share_your_pwn_epr_registration"
												type="text"
												onChange={handleDataChange}
											/>
											{errorMessage.secondary_share_your_pwn_epr_registration && (
												<span className={styles['errormsg']}>
													{errorMsg.errorMsgForSecondaryPWNRegistration}
												</span>
											)}
										</div>
									</div>

									{/* Secondary Share Your Plastic Packaging Supplier PWM EPR Registration Number */}
									<div className={styles['form-data']}>
										<label className={styles['form-label']}>
											Share your plastic packaging supplier PWM EPR Registration
											Number (As a producer/manufacturer)*
										</label>
										<div className={styles['user-group']}>
											<input
												className={styles['text-box']}
												value={
													packagingDetails.secondary_share_your_plastic_packaging_supplier_pwm_epr_registration_number
												}
												name="secondary_share_your_plastic_packaging_supplier_pwm_epr_registration_number"
												type="text"
												onChange={handleDataChange}
											/>
											{errorMessage.secondary_share_your_plastic_packaging_supplier_pwm_epr_registration_number && (
												<span className={styles['errormsg']}>
													{
														errorMsg.errorMsgForSecondarySupplierRegistrationNumber
													}
												</span>
											)}
										</div>
									</div>

									{/* Secondary Are You Complying With the PWM EPR Labeling Requirement */}
									<div className={styles['form-data']}>
										<label className={styles['form-label']}>
											Are You Complying With the PWM EPR Labeling Requirement ?*
										</label>
										<div className={styles['user-group']}>
											<input
												className={styles['text-box']}
												value={
													packagingDetails.secondary_are_you_complying_with_the_pwm_epr_labeling_requirement
												}
												name="secondary_are_you_complying_with_the_pwm_epr_labeling_requirement"
												type="text"
												onChange={handleDataChange}
											/>
											{errorMessage.secondary_are_you_complying_with_the_pwm_epr_labeling_requirement && (
												<span className={styles['errormsg']}>
													{errorMsg.errorMsgForSecondaryLabelingRequirement}
												</span>
											)}
										</div>
									</div>

									{/* Secondary Are You Complying With the PWN EPR Plastic Packaging Recycling Requirement */}
									<div className={styles['form-data']}>
										<label className={styles['form-label']}>
											Are You Complying With the PWN EPR Plastic Packaging
											Recycling Requirement ?*
										</label>
										<div className={styles['user-group']}>
											<input
												className={styles['text-box']}
												value={
													packagingDetails.secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement
												}
												name="secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement"
												type="text"
												onChange={handleDataChange}
											/>
											{errorMessage.secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement && (
												<span className={styles['errormsg']}>
													{errorMsg.errorMsgForSecondaryRecyclingRequirement}
												</span>
											)}
										</div>
									</div>

									{/* Secondary Are You Complying With the PWN EPR Plastic Packaging Recycled Content Requirement */}
									<div className={styles['form-data']}>
										<label className={styles['form-label']}>
											Are You Complying With the PWN EPR Plastic Packaging
											Recycled Content Requirement ?*
										</label>
										<div className={styles['user-group']}>
											<input
												className={styles['text-box']}
												value={
													packagingDetails.secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement
												}
												name="secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement"
												type="text"
												onChange={handleDataChange}
											/>
											{errorMessage.secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement && (
												<span className={styles['errormsg']}>
													{
														errorMsg.errorMsgForSecondaryRecycledContentRequirement
													}
												</span>
											)}
										</div>
									</div>

									{/* Secondary What Is the Current Percent of Recycled Content in the Plastic Packaging of the Parts */}
									<div className={styles['form-data']}>
										<label className={styles['form-label']}>
											What is the current % of recycled content in the plastic
											packaging of the parts ?*
										</label>
										<div className={styles['user-group']}>
											<input
												className={styles['text-box']}
												value={
													packagingDetails.secondary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts
												}
												name="secondary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts"
												type="percentage"
												onChange={handleDataChange}
											/>
											{errorMessage.secondary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts && (
												<span className={styles['errormsg']}>
													{errorMsg.errorMsgForSecondaryRecycledContentPercent}
												</span>
											)}
										</div>
									</div>

									{/* Secondary Remarks Other Details */}
									<div className={styles['form-data']}>
										<label className={styles['form-label']}>
											Remarks/Any Other Details*
										</label>
										<div className={styles['user-group']}>
											<input
												className={styles['text-box']}
												value={packagingDetails.secondary_remarks_other_details}
												name="secondary_remarks_other_details"
												type="text"
												onChange={handleDataChange}
											/>
											{errorMessage.secondary_remarks_other_details && (
												<span className={styles['errormsg']}>
													{errorMsg.errorMsgForSecondaryRemarks}
												</span>
											)}
										</div>
									</div>
								</>
							)}
						</form>
						<div className={styles.label}>
							For More Details, Visit the link: <a className={styles.value} href="https://eprplastic.cpcb.gov.in/#/plastic/home" target="_blank"> https://eprplastic.cpcb.gov.in/#/plastic/home </a>
						</div>
					</div>
					<div className={styles['subSection']}>
						<div className={styles['form-head']}>
							<span>SHIPPING & LOGISTICS</span>
						</div>
						<form className={styles['form-body']}>
							{/* Transportation Mode */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Transportation Mode (Vehicle type / Size)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.transportation_mode}
										name="transportation_mode"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.transportation_mode && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForTransportationMode}
										</span>
									)}
								</div>
							</div>

							{/* Pallet Dimensions */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Pallet Dimensions (LXWXH) (mm)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.pallet_dimensions}
										name="pallet_dimensions"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.pallet_dimensions && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPalletDimensions}
										</span>
									)}
								</div>
							</div>

							{/* No. of Pallets per vehicle */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									No. of Pallets per vehicle*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.no_of_pallets_per_vehicle}
										name="no_of_pallets_per_vehicle"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.no_of_pallets_per_vehicle && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForNoOfPalletPerVehicle}
										</span>
									)}
								</div>
							</div>

							{/* Stackable/ Non stackable (If "Stackable" then no. of stacking allowed) */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Stackable/ Non stackable (If "Stackable" then no. of stacking
									allowed)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.stackable_non_stackable}
										name="stackable_non_stackable"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.stackable_non_stackable && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForStackable}
										</span>
									)}
								</div>
							</div>

							{/* Secondary Packaging per Transit Modes */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Sec Packaging per transit modes*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.sec_packaging_per_transit_modes}
										name="sec_packaging_per_transit_modes"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.sec_packaging_per_transit_modes && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSecPackagingPerTransitModes}
										</span>
									)}
								</div>
							</div>

							{/* Number of Primary Packs per Secondary Packs */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									No of Pry Packs per Sec Packs*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.no_of_pry_packs_per_sec_packs}
										name="no_of_pry_packs_per_sec_packs"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.no_of_pry_packs_per_sec_packs && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForNoOfPryPacksPerSecPacks}
										</span>
									)}
								</div>
							</div>

							{/* Inco Term */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>INCO Terms*</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.inco_term}
										name="inco_term"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.inco_term && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForIncoTerm}
										</span>
									)}
								</div>
							</div>

							{/* Hazardous Material Class */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Hazardous Material Class*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.hazardous_material_class}
										name="hazardous_material_class"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.hazardous_material_class && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForHazardousMaterialClass}
										</span>
									)}
								</div>
							</div>

							{/* Loop Size */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									loop Size ( for Returnable)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.loop_size}
										name="loop_size"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.loop_size && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForLoopSize}
										</span>
									)}
								</div>
							</div>

							{/* Life of Returnable Packaging */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Life of Returnable Packaging*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.life_of_returnable_packaging}
										name="life_of_returnable_packaging"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.life_of_returnable_packaging && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForLifeOfReturnablePackaging}
										</span>
									)}
								</div>
							</div>

							{/* Unloading/Loading Responsibility */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Unloading & Loading responsibility*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.unloading_loading_responsibility}
										name="unloading_loading_responsibility"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.unloading_loading_responsibility && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForUnloadingLoadingResponsibility}
										</span>
									)}
								</div>
							</div>

							{/* Supply at TML */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Supply at TMPVL/TPEM ( Supplier Scope)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.supply_at_tml}
										name="supply_at_tml"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.supply_at_tml && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSupplyAtTML}
										</span>
									)}
								</div>
							</div>

							{/* Theoretical Cubic Utilisation */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Theoretical Cubic Utilisation / No of Parts per Transport mode*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.theoretical_cubic_utilisation}
										name="theoretical_cubic_utilisation"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.theoretical_cubic_utilisation && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForTheoreticalCubicUtilisation}
										</span>
									)}
								</div>
							</div>

							{/* Remarks */}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>Remarks*</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.remarks}
										name="remarks"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.remarks && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForRemarks}
										</span>
									)}
								</div>
							</div>
						</form>
					</div>

					{/* <div className={styles['subSection']}> */}
					{/* <div className={styles['form-head']}>
							<span>APPROVAL INFORMATION</span>
						</div> */}
					{/* <form className={styles['form-body']}> */}
					{/* Packaging Person */}
					{/* <div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Packaging Person (Supplier)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.packaging_person}
										name="packaging_person"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.packaging_person && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPackagingPerson}
										</span>
									)}
								</div>
							</div> */}

					{/* Purchasing Buyer TML */}
					{/* <div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Purchasing Buyer (TMPVL/TPEM)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.purchasing_buyer_tml}
										name="purchasing_buyer_tml"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.purchasing_buyer_tml && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPurchasingBuyerTML}
										</span>
									)}
								</div>
							</div> */}

					{/* SCM TML */}
					{/* <div className={styles['form-data']}>
								<label className={styles['form-label']}>
									SCM ( TMPVL/TPEM)*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['text-box']}
										value={packagingDetails.scm_tml}
										name="scm_tml"
										type="text"
										onChange={handleDataChange}
									/>
									{errorMessage.scm_tml && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSCMTML}
										</span>
									)}
								</div>
							</div> */}

					{/* Packaging Person Date */}
					{/* <div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Packaging Person Date*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['date-field']}
										value={packagingDetails.packaging_person_date}
										name="packaging_person_date"
										type="date"
										onChange={handleDataChange}
									/>
									{errorMessage.packaging_person_date && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPackagingPersonDate}
										</span>
									)}
								</div>
							</div> */}

					{/* Purchasing Buyer TML Date */}
					{/* <div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Purchasing Buyer TML Date*
								</label>
								<div className={styles['user-group']}>
									<input
										className={styles['date-field']}
										value={packagingDetails.purchasing_buyer_tml_date}
										name="purchasing_buyer_tml_date"
										type="date"
										onChange={handleDataChange}
									/>
									{errorMessage.purchasing_buyer_tml_date && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForPurchasingBuyerTMLDate}
										</span>
									)}
								</div>
							</div> */}

					{/* SCM TML Date */}
					{/* <div className={styles['form-data']}>
								<label className={styles['form-label']}>SCM TML Date*</label>
								<div className={styles['user-group']}>
									<input
										className={styles['date-field']}
										value={packagingDetails.scm_tml_date}
										name="scm_tml_date"
										type="date"
										onChange={handleDataChange}
									/>
									{errorMessage.scm_tml_date && (
										<span className={styles['errormsg']}>
											{errorMsg.errorMsgForSCMTMLDate}
										</span>
									)}
								</div>
							</div> */}
					{/* </form> */}
					{/* </div> */}

					<div className={styles['subSection']}>
						<div className={styles['form-head']}>
							<span>APPROVAL DETAILS</span>
						</div>
						<form className={styles['form-body']}>
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>Plant*</label>
								<div className={styles['user-group']}>
									<Select
										options={plantDataList}
										value={select.selected_plant_id}
										className={styles['dropDown']}
										onChange={(e) => handleAssigneeValue(e, 'selected_plant')}
										isDisabled={isEdited}
									/>
								</div>
							</div>


							{/*Commodity Type*/}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Commodity Type*
								</label>
								<div className={styles['user-group']}>
									<Select
										className={styles['dropDown']}
										placeholder={'Select Commodity Type'}
										options={commodityTypeList}
										value={select.selected_commodity_type_details}
										onChange={(e) => handleAssigneeValue(e, 'selected_commodity_type_details')}
										isDisabled={!select.selected_plant_id || isEdited}
									/>
								</div>
							</div>

							{/*Select DMP Buyer*/}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									DMP Buyer*
								</label>
								<div className={styles['user-group']}>
									<Select
										className={styles['dropDown']}
										placeholder={'Select DMP Buyer'}
										value={select.selected_dmp_user_details}
										options={directMaterialPurchaseBuyerList}
										onChange={(e) =>
											handleAssigneeValue(e, 'selected_dmp_user_details')
										}
										isDisabled={!select.selected_commodity_type_details || !select.selected_plant_id || isEdited}
									/>
								</div>
							</div>

							{/*Excel Attachment*/}
							<div className={styles['form-data']}>
								<label className={styles['form-label']}>
									Excel Attachment*
								</label>
								<div className={styles['user-group']}>
									{/* File Input for Excel File */}
									<FileInputSection
										name="excel_attachment"
										onChange={handleFileChange}
										editName={'Attached Excel File'}
										isEdited={isEdited || isDrafted}
										fileURL={""}
										acceptTypes=".xls,.xlsx,.xlsm" // Accept only Excel files
									/>
								</div>
							</div>
						</form>
					</div>
				</div>

				<div className={styles['subSection']}>
					<div
						className={clsx(
							styles.approvalInformation,
							styles.recyclingGuidelines
						)}
					>
						{/* First Table: Plastic Packaging Recycling Guidelines */}
						<div className={styles.recyclingGuideLinesTable}>
							<div className={styles.recyclingHeading}>
								Plastic Packaging Recycling Guidelines (%)
							</div>
							{renderGuidelinesTable(plasticPackagingRecyclingGuidelines)}
						</div>

						{/* Second Table: Plastic Packaging Recycled Content Guidelines */}
						<div className={styles.recyclingGuideLinesTable}>
							<div className={styles.recyclingHeading}>
								Plastic Packaging Recycled Content Guidelines (%)
							</div>
							{renderGuidelinesTable(recycledContentGuidelines)}
						</div>
					</div>
				</div>

				<div className={styles['button-container']}>
					{(window?.location?.pathname?.includes('add-strategy') ||
						window?.location?.pathname?.includes('draft-strategy')) && (
						<div className={styles.button}>
							<Button
								variant="primary"
								onClick={() => {
									darftForm();
								}}
								disabled={isButtonDisabled}
							>
								Save as Draft
							</Button>
						</div>
					)}
					<div className={styles.button}>
						<Button
							variant="okButton"
							onClick={() => {
								if (missingRecommendedFields?.length > 0) {
									// Show confirmation modal if there are missing recommended fields
									setIsConfirmationModalOpen(true);
								} else {
									// Otherwise, directly submit the form
									submitForm(); // Call your form submission function here
								}
							}}
							disabled={isButtonDisable}
						>
							Submit
						</Button>
					</div>
				</div>
			</div>
			{
				<SuccessModal
					open={isModalOpen}
					handleClose={() => navigate('/packaging-strategy')}
					title={title}
				/>
			}
			{
				<ErrorModal
					open={isErrorModalOpen}
					title={title}
					handleClose={() => setIsErrorModalOpen(false)}
					code={statusCode}
				/>
			}
			{
				<ConfirmationModal
					open={isConfirmationModalOpen}
					missingFields={missingRecommendedFields}
					onConfirm={handleWarningAcknowledgement}
					handleClose={() => {
						setIsConfirmationModalOpen(false);
					}}
					title={commonVaribles.image_submission_confirmation}
					errorMsg={errorMessage}
				/>
			}
		</div>
	);
};
